import React from "react";
import Drawer from "rc-drawer";

function MainDrawer({ children, drawerOpen, closeDrawer }) {
  return (
    drawerOpen ? <Drawer
      open={drawerOpen}
      onClose={closeDrawer}
      level={null}
      placement="top"
      height={"100vh"}
    >
      {children}
    </Drawer> : null
  );
}

export default MainDrawer;
